import React from 'react';
import Icon from '../../../components/AppIcon';

const ColumnPreview = ({ detectedColumns, sampleData }) => {
  const columnMappings = {
    'nome': { icon: 'Tag', color: 'text-blue-600', label: 'Nome do Produto' },
    'sku': { icon: 'Hash', color: 'text-purple-600', label: 'SKU' },
    'preco': { icon: 'DollarSign', color: 'text-green-600', label: 'Preço' },
    'custo': { icon: 'TrendingDown', color: 'text-orange-600', label: 'Custo' },
    'categoria': { icon: 'Folder', color: 'text-indigo-600', label: 'Categoria' },
    'peso': { icon: 'Weight', color: 'text-gray-600', label: 'Peso' },
    'imagem': { icon: 'Image', color: 'text-pink-600', label: 'Imagem' },
    'estoque': { icon: 'Package', color: 'text-teal-600', label: 'Estoque' }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center justify-center w-10 h-10 rounded-md bg-primary/10">
          <Icon name="Table" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h4 className="font-medium text-foreground">Colunas Detectadas</h4>
          <p className="caption text-muted-foreground">
            {detectedColumns?.length} colunas identificadas automaticamente
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {detectedColumns?.map((column, index) => {
          const mapping = columnMappings?.[column?.toLowerCase()] || {
            icon: 'FileText',
            color: 'text-muted-foreground',
            label: column
          };

          return (
            <div
              key={index}
              className="flex items-center gap-3 p-3 rounded-md bg-muted/50 border border-border"
            >
              <div className="flex items-center justify-center w-8 h-8 rounded-md bg-background">
                <Icon name={mapping?.icon} size={16} className={mapping?.color} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="caption font-medium text-foreground truncate">
                  {mapping?.label}
                </p>
                <p className="caption text-muted-foreground text-xs truncate">
                  {sampleData?.[index] || 'Sem dados'}
                </p>
              </div>
              <Icon name="Check" size={16} className="text-success flex-shrink-0" />
            </div>
          );
        })}
      </div>
      <div className="mt-4 p-3 rounded-md bg-success/10 border border-success/20">
        <div className="flex items-start gap-2">
          <Icon name="CheckCircle2" size={16} className="text-success mt-0.5 flex-shrink-0" />
          <p className="caption text-foreground">
            Todas as colunas obrigatórias foram detectadas. O arquivo está pronto para processamento.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ColumnPreview;